__turbopack_context__.v({
  "remixSlideDown": "pfhYsa_remixSlideDown",
  "remixSlideLeft": "pfhYsa_remixSlideLeft",
  "remixSlideRight": "pfhYsa_remixSlideRight",
  "remixSlideUp": "pfhYsa_remixSlideUp",
  "slideDown": "pfhYsa_slideDown",
  "slideLeft": "pfhYsa_slideLeft",
  "slideRight": "pfhYsa_slideRight",
  "slideUp": "pfhYsa_slideUp",
  "tile": "pfhYsa_tile",
});
